export default __webpack_public_path__ + "static/media/Mask Group 27@2x.3b887858.png";